<template>
  <div>
    <div class="el-card__header card-header__wrap">
      <span class="card-header--title"></span>
      <div class="card-header--form">
        <el-input placeholder="请输入企业名称"
          v-model="config.vendorName"
          style="width:200px"
          clearable>
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
    </div>
    <el-table border
      v-loading="loading"
      :data="list">
      <el-table-column label="购买企业"
        prop="vendorName">
      </el-table-column>
      <el-table-column label="已购套码数量"
        prop="assignedSetCount">
      </el-table-column>
      <el-table-column label="剩余套码数量"
        prop="remainSetCount">
      </el-table-column>
      <el-table-column label="最近购买时间"
        width="140">
        <template slot-scope="{row}">
          {{row.latelyAssignTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column label="操作"
        width="120">
        <template slot-scope="{row}">
          <el-button type="text"
            @click="viewDetail(row)">查看明细</el-button>
          <el-button type="text"
            @click="produceCode(row)">生产</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
      @current-change="handleCurrentChange"
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
    <ent-set-detail-modal ref="modal" />
    <ent-set-produce-modal :fetch="()=> {handleCurrentChange(1)}"
      ref="produceModal" />
  </div>
</template>

<script>
import EntSetProduceModal from './ent-set-produce-modal.vue'
import EntSetDetailModal from './ent-set-detail-modal.vue'
export default {
  name: 'ent-set-distribute-table',
  components: { EntSetDetailModal, EntSetProduceModal },
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        isPreassign: 1,
        vendorName: ''
      },
      list: [],
      total: 0
    }
  },
  methods: {
    getsetassignsums () {
      this.loading = true
      this.$store.dispatch('label/getsetassignsums', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.getsetassignsums()
    },
    viewDetail (row) {
      this.$refs.modal.fetch({
        vendorId: row.vendorId,
        vendorName: row.vendorName
      })
    },
    produceCode (row) {
      this.$refs.produceModal.init(row)
    }
  },
  mounted () {
    this.getsetassignsums()
  }
}
</script>
